/* eslint-disable */
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import Img from "../components/Img";

function num(v) { return v == null ? "—" : Number(v).toLocaleString(); }
function pct(v) { return v == null ? "—" : `${Math.round(v * 100)}%`; }

function PublicHeader() {
  return (
    <header className="rec-topbar">
      <Link to="/spaces" className="rec-brand">
        <span className="rec-brand-mark"><img src="/brand/metier-icon.png" alt="Métier" /></span>
      </Link>
      <nav className="rec-topnav">
        <Link to="/spaces">Spaces</Link>
        <Link to="/list-your-space">List your space</Link>
        <Link to="/login">Member sign in</Link>
      </nav>
    </header>
  );
}

export default function PartnerDashboard() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/partner/${slug}`)
      .then(r => setData(r.data))
      .catch(e => setErr(e?.response?.data?.detail || "Partner dashboard not found."));
  }, [slug]);

  if (err) return (
    <div className="rec-page"><PublicHeader /><div className="rec-main">
      <span className="rec-eyebrow">Métier · Partner</span>
      <h1 className="rec-h1">Not <em>found</em>.</h1>
      <p className="rec-desc">{err} <Link to="/spaces" style={{color:"var(--gold)"}}>Back to all spaces →</Link></p>
    </div></div>
  );
  if (!data) return <div className="rec-page"><PublicHeader /><div className="m-loading-inline">Loading partner analytics…</div></div>;

  const w = data.workspace;
  const t = data.traffic;
  const v = data.validation;
  const fb = data.feedback;

  return (
    <div className="rec-page" data-testid={`partner-dashboard-${slug}`}>
      <PublicHeader />
      <main className="rec-main" style={{maxWidth: 1080}}>
        <span className="rec-eyebrow">Métier · Partner dashboard</span>
        <h1 className="rec-h1" style={{maxWidth: 800}}>
          Here&apos;s what Métier is <em>already</em> doing for <strong>{w.name}</strong>.
        </h1>
        <p className="rec-desc" style={{maxWidth: 600}}>
          You&apos;re listed on the Métier network for <strong>{w.city}</strong>. This page shows the traffic, demand, and validation your space is receiving through Métier, before we&apos;ve even signed a formal partnership.
        </p>

        <div className="m-partner-grid">
          <section className="m-partner-hero">
            {w.img && <div className="m-partner-hero-img"><Img src={w.img} alt={w.name} /></div>}
            <div className="m-partner-hero-body">
              <span className="rec-eyebrow" style={{color:"var(--gold)"}}>{w.type}</span>
              <h2 className="rec-h2" style={{margin:"6px 0 4px"}}>{w.name}</h2>
              <p className="m-muted small">{w.neighborhood} · {w.city}</p>
              {w.external_booking && w.booking_url && (
                <a href={w.booking_url} target="_blank" rel="noopener noreferrer" className="m-btn-gold" style={{marginTop:14,display:"inline-block"}} data-testid="partner-booking-url">
                  Your public booking page →
                </a>
              )}
            </div>
          </section>

          <section className="m-partner-kpis" data-testid="partner-kpis">
            <div className="m-partner-kpi">
              <div className="m-partner-kpi-val">{num(t.profile_views)}</div>
              <div className="m-partner-kpi-label">Profile views</div>
              <div className="m-partner-kpi-hint">Members who landed on your listing</div>
            </div>
            <div className="m-partner-kpi">
              <div className="m-partner-kpi-val">{num(t.external_clicks_total)}</div>
              <div className="m-partner-kpi-label">Booking clicks</div>
              <div className="m-partner-kpi-hint">Referrals to your booking site<br/><strong>+{num(t.external_clicks_7d)}</strong> last 7 days</div>
            </div>
            <div className="m-partner-kpi">
              <div className="m-partner-kpi-val" style={{color:"var(--gold)"}}>{num(data.demand.partner_requests)}</div>
              <div className="m-partner-kpi-label">Partner requests</div>
              <div className="m-partner-kpi-hint">Members who&apos;ve asked us to formalize this space as an official Métier partner</div>
            </div>
            <div className="m-partner-kpi">
              <div className="m-partner-kpi-val">{v.avg_rating ? Number(v.avg_rating).toFixed(1) : "—"}</div>
              <div className="m-partner-kpi-label">Average rating</div>
              <div className="m-partner-kpi-hint">{num(v.review_count)} verified review{v.review_count === 1 ? "" : "s"}</div>
            </div>
          </section>

          <section className="m-partner-section" data-testid="partner-validation-badges">
            <span className="rec-eyebrow" style={{color:"var(--gold)"}}>Community validation</span>
            <h3 className="m-partner-h3">Popular with · Validated for</h3>
            <div className="m-partner-badges">
              {(v.popular_with || []).length === 0 && (v.validated_for || []).length === 0 ? (
                <div className="m-muted small">Once members complete reviews, this section fills up with automatic badges, never manually assigned.</div>
              ) : (
                <>
                  {(v.popular_with || []).map(p => (
                    <span key={`pw-${p.profession}`} className="m-partner-badge popular" data-testid={`badge-popular-${p.profession}`}>
                      Popular with <strong>{p.label}</strong>
                    </span>
                  ))}
                  {(v.validated_for || []).map(x => (
                    <span key={`vf-${x.key}`} className="m-partner-badge validated" data-testid={`badge-validated-${x.key}`}>
                      Validated for <strong>{x.label}</strong>
                    </span>
                  ))}
                </>
              )}
            </div>
          </section>

          <section className="m-partner-section" data-testid="partner-traffic-sources">
            <span className="rec-eyebrow" style={{color:"var(--gold)"}}>Where your traffic comes from</span>
            <h3 className="m-partner-h3">Referral sources</h3>
            {(t.by_source || []).length === 0 ? (
              <div className="m-muted small">No referral traffic yet.</div>
            ) : (
              <table className="m-utm-table">
                <thead><tr><th>Source page</th><th style={{textAlign:"right"}}>Clicks</th></tr></thead>
                <tbody>
                  {t.by_source.map(r => (
                    <tr key={r.source}><td>{r.source}</td><td style={{textAlign:"right"}}><strong>{r.clicks}</strong></td></tr>
                  ))}
                </tbody>
              </table>
            )}
          </section>

          <section className="m-partner-section" data-testid="partner-feedback">
            <span className="rec-eyebrow" style={{color:"var(--gold)"}}>What members say</span>
            <h3 className="m-partner-h3">Post-click feedback</h3>
            <div className="m-partner-fb-row">
              <div className="m-partner-fb-cell">
                <div className="m-partner-fb-num">{num(fb.returns_after_click)}</div>
                <div className="m-partner-fb-lbl">Return prompts answered</div>
              </div>
              <div className="m-partner-fb-cell">
                <div className="m-partner-fb-num">{num(fb.reported_booked)}</div>
                <div className="m-partner-fb-lbl">Reported booking</div>
              </div>
              <div className="m-partner-fb-cell">
                <div className="m-partner-fb-num">{pct(fb.booking_conversion)}</div>
                <div className="m-partner-fb-lbl">Booking conversion</div>
              </div>
            </div>
          </section>

          <section className="m-partner-cta" data-testid="partner-cta">
            <h3 className="m-partner-h3">Ready to become a formal Métier partner?</h3>
            <p className="rec-desc">Bookable directly through Métier · transparent per-booking fees, keep the rest · nothing to install, no monthly cost.</p>
            <Link to="/list-your-space" className="m-btn-gold" style={{marginTop:12,display:"inline-block"}}>Talk to us →</Link>
          </section>
        </div>
      </main>
      <footer className="rec-footer">
        <span>© Métier · workmetier.app · <Link to="/support" style={{color:"var(--m-muted)"}}>Support</Link></span>
        <span><Link to="/spaces" style={{color:"var(--gold)"}}>All spaces →</Link></span>
      </footer>
    </div>
  );
}
